/**
 * Created by patrick.cunha on 30/05/2018.
 */

export default class DateUtil {
  constructor() {
    throw new Error('Esta classe não pode ser instanciada')
  }

  static pad(str, length) {
    let resto = length - String(str).length
    return '0'.repeat(resto > 0 ? resto : '0') + str
  }

  static dateToText(data) {
    if (!data) throw new Error('Necessário informar uma data')
    if (data instanceof Date) {
      return `${data.getDate()}/${this.pad(data.getMonth() + 1, 2)}/${data.getFullYear()}`
    }

    if (typeof data === 'string') {
      if (data.indexOf('T') !== -1) {
        data = data.slice(0, data.indexOf('T'))
      }

      const [year, month, day] = data.split('-')
      return `${day}/${month}/${year}`
    }
  }

  static parseISO(data) {
    if (!data) throw new Error('Necessário informar uma data')

    data = typeof data === 'string' ? data : DateUtil.dateToText(data)
    const [day, month, year] = data.split('/')
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
  }

  static textToDate(texto) {
    if (!/\d{2}\/\d{2}\/\d{4}/.test(texto)) {
      throw new Error('Deve estar no formato dd/mm/aaaa')
    }

    return new Date(...texto.split('/').reverse().map((item, indice) => item - indice % 2))
  }

  static isValid(dateString) {
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) return false

    let parts = dateString.split('/')
    let day = parseInt(parts[0], 10)
    let month = parseInt(parts[1], 10)
    let year = parseInt(parts[2], 10)

    if (year < 1000 || year > 3000 || month === 0 || month > 12) return false

    let monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
    // Adjust for leap years
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
      monthLength[1] = 29
    }
    return day > 0 && day <= monthLength[month - 1]
  }

  static diff(dataInicial, dataFinal) {
    let dtInicio = null, dtFim = null

    if (dataInicial instanceof Date) {
      dtInicio = dataInicial
    } else {
      if (/\d{2}\/\d{2}\/\d{4}/.test(dataInicial)) {
        dtInicio = DateUtil.textToDate(dataInicial)
      } else {
        dtInicio = DateUtil.textToDate(DateUtil.dateToText(dataInicial))
      }
    }
    if (dataFinal instanceof Date) {
      dtFim = dataFinal
    } else {
      if (/\d{2}\/\d{2}\/\d{4}/.test(dataFinal)) {
        dtFim = DateUtil.textToDate(dataFinal)
      } else {
        dtFim = DateUtil.textToDate(DateUtil.dateToText(dataFinal))
      }
    }

    if (!dtInicio || !dtFim) throw new Error('Deve estar no formato dd/mm/aaaa')

    let timeDiff = Math.abs(dtFim.getTime() - dtInicio.getTime())
    return Math.ceil(timeDiff / (1000 * 3600 * 24))
  }

  /**
   * Converte a quantidade de segundos em minutos no formato MM:ss.
   * 280 -> 04:40
   *
   * @param {Number} segundos
   */
  static converterSegundosEmMinutos(segundos) {
    const minutos = DateUtil.pad(Math.floor(segundos / 60), 2);
    const segundosFormatados = DateUtil.pad((segundos % 60), 2);
    return `${minutos}:${segundosFormatados}`;
  }
}

